import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ConversationalAssessment } from "@/components/assessment/ConversationalAssessment";
import { AssessmentModule } from "@/types/assessment";
import { useAssessment } from "@/context/AssessmentContext";

interface AssessmentOverlayProps {
  module: AssessmentModule | null;
  onOpenChange: (open: boolean) => void;
}

export function AssessmentOverlay({ module, onOpenChange }: AssessmentOverlayProps) {
  const { updateModuleStatus } = useAssessment();

  if (!module) return null;

  const handleClose = () => {
    onOpenChange(false);
  };

  const handleComplete = () => {
    if (module) {
      updateModuleStatus(module.id, "complete");
    }
    handleClose();
  };

  return (
    <Dialog open={!!module} onOpenChange={onOpenChange}>
      <DialogContent 
        className="w-full max-w-4xl h-[80vh] flex flex-col p-0"
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="sr-only">
          <DialogTitle>{module.title}</DialogTitle>
          <DialogDescription>
            {module.description}
          </DialogDescription>
        </DialogHeader>
        
        <div className="h-full flex flex-col">
          <ConversationalAssessment 
            moduleId={module.id}
            onComplete={handleComplete}
            onExit={handleClose}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}